<template>
    <div>
      
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Student List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
                <v-row justify="center">
                    <v-col cols="5">
                        <v-autocomplete :items="learner_list" item-text="learner" item-value="id" dense outlined :loading="learner_loader"
                            label="Student List" @change="getParentDetails(selected_student)"
                            v-model="selected_student"> </v-autocomplete>
                    </v-col>
                    <v-col cols="5">
                        <v-autocomplete :items="parent_list" item-text="parent" item-value="id" dense outlined :loading="learner_loader"
                            @change="getStudentDetails(selected_parent)" label="Parent List" v-model="selected_parent">
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-btn class="mb-2 button" small @click="save()" :loading="loader">Save</v-btn>
                    <!-- <v-btn class="mb-2 button" v-if="tenant == 'wws'" small @click="saveSecondarParent()" :loading="loader">Save Secondary Parent</v-btn>  -->
                    <v-btn class="mb-2 button" small @click="saveSecondarParent()" :loading="loader">Save Secondary
                        Parent</v-btn>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Parent Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn class="mb-2 button" @click="add_parent_dialog = true" small>Add New Parent</v-btn>
            </v-toolbar>
            <v-card-text>
                <template v-if="parent_details !=null">
                    <v-data-table :items="parent_details" :headers="headers" class="elevation-1 mytable" dense
                        :search="search"> </v-data-table>
                </template>
            </v-card-text>
        </v-card>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Student Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <template v-if="learner_details !=null">
                    <v-data-table :items="learner_details" :headers="learner_headers" class="elevation-1 mytable" dense
                        :search="search"> </v-data-table>
                </template>
            </v-card-text>
        </v-card>

        <v-dialog v-model="add_parent_dialog" max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Add New Parent</strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Enter Email*</b></p>
                                <v-text-field v-model="parent_email" :rules="[rules.required, rules.uid]"
                                    prepend-icon="email" placeholder="Please Enter your email for Signup" clearable
                                    :hint="disabled == 1 ?'noneditable':'For example, admin@edupluscampus.com'"
                                    :disabled="disabled == 1 ? true : false" required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="addNewParent()" :loading="loader">save</v-btn>
                            <v-btn class="button" @click="add_parent_dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
    components: {
        Breadcrumbs,
    },

        data: () => ({
            rules: {
                parent_email: "",
                required: (value) => !!value || "Required.",
                uid: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            },
            loader: false,
            add_parent_dialog: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            learner_list: [],
            parent_list: [],
            selected_student: "",
            selected_parent: "",
            parent_details: [],
            learner_details: [],
            learner_loader: false,
            search:"",
            parent_email:null,
            disabled: 0,
            tenant: null,
            headers: [
                { text: "Parent Name", value: "parent", sortable: true },
                { text: "Contact", value: "contact", sortable: true },
                { text: "Email", value: "email", sortable: true },
                { text: "Login Id", value: "login_id", sortable: true },
            ],
            learner_headers: [
                { text: "Student Name", value: "learner", sortable: true },
                { text: "Contact", value: "contact", sortable: true },
                { text: "Email", value: "email", sortable: true },
                { text: "Login Id", value: "login_id", sortable: true },
                { text: "Date Of Birth", value: "DOB", sortable: true },
            ],
        }),
         created() {
            this.tenant = localStorage.getItem("EPS-tenant");
        },
        methods: {
            addNewParent() {
                this.loader = true;
                const formData = {
                    parent_email: this.parent_email,
                };
                axios
                    .post("RoleManagement/addNewParent", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.showSnackbar("#4CAF50", "Added Successfully..");
                            this.add_parent_dialog = false;
                            this.parent_email = "";
                            this.onload();
                        } else if (res.data.flag == "No") {
                            this.loader = false;
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            saveSecondarParent(){
               this.loader = true;
                const formData = {
                    learner: this.selected_student,
                    parent: this.selected_parent,
                };
                axios
                    .post("RoleManagement/saveSecondarParent", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.parent_details = res.data.parent_details;
                            this.showSnackbar("#4CAF50", "Mapped Successfully..");
                            this.onload();
                        } else if(res.data.status == "NO"){
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        }
                        else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                            this.loader = false;
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            save() {
                this.loader = true;
                const formData = {
                    learner: this.selected_student,
                    parent: this.selected_parent,
                };
                axios
                    .post("RoleManagement/saveMapping", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.parent_details = res.data.parent_details;
                            this.loader = false;
                            this.showSnackbar("#4CAF50", "Mapped Successfully..");
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getParentDetails(item) {
                const formData = {
                    learner: item,
                };
                // alert(formData.learner)
                axios
                    .post("RoleManagement/getParentDetails", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.parent_details = res.data.parent_details;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            getStudentDetails(item) {
                const formData = {
                    parentid: item,
                };
                //alert(formData.parentid)
                axios
                    .post("RoleManagement/getStudentDetails", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.learner_details = res.data.learner_details;
                            this.showSnackbar("green", res.data.status_reason);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            onload() {
                this.learner_loader = true;
                axios
                    .post("RoleManagement/mapParentToStudent")
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.learner_list = res.data.learner_list;
                            this.parent_list = res.data.parent_list;
                            this.learner_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                            this.learner_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.learner_loader = false;
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
        watch: {},
    };
</script>
<style scoped>
    @media (min-width: 320px) and (max-width: 767.98px) {
    }
    @media (min-width: 768px) and (max-width: 991.98px) {
    }
    @media (min-width: 992px) and (max-width: 1024px) {
    }
</style>
